// SuccessPage.jsx
import React from "react";
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
// import { mobnav, seo } from '../../helper/Script';
// import { setTittle, scrollTop } from '../../helper/formvalidation';
// At runtime, Redux will merge together...
type CounterProps = RouteComponentProps<{}>;
var languagecontent: any = "";
class FlexiSuccess extends React.PureComponent<CounterProps> {
    constructor(props: any) {
        super(props);
    }
    // This method is called when the component is first added to the document
    public componentDidMount() {
        //scrollTop();      

    }
    componentDidUpdate() {
        //seo(setTittle(languagecontent == "" ? "" : languagecontent['breadcrumb']));
    }

    public render() {
        return (
            <React.Fragment>
                {this.renderSuccess()}
            </React.Fragment>
        );
    }

    private renderSuccess() {
        // console.log(this.props.success.statusId)
        //languagecontent = this.props.LanguageResoures;
        return (
            <React.Fragment>
                <br />
                <br /><br /><br />
                <div className="success-cont"><i className="fas fa-check"></i>
                    <br />
                    <p className="success-exp"> Forms Submitted Successfully. </p>
                </div>
                <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                <br />

                </React.Fragment>
                    );
    }
}
export default connect(
   
)(FlexiSuccess as any);
